import Select, { GroupBase, Props } from 'react-select';

const customStyles = {
  indicatorSeparator: () => ({
    display: 'none'
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: '10px',
    height: '32px',
    borderRadius: '0.375rem',
    borderColor: state.isFocused ? '#f4c83e' : '#d1d5db',
    boxShadow: 'none',
    fontSize: '0.875rem',
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    '&:hover': {
      borderColor: '#f4c83e',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    height: '30px',
    padding: '0 6px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: '0',
    padding: '0',
    height: '30px',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#000',
    margin: '0',
    padding: '0',
    fontSize: '0.875rem',
    fontWeight: '400',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    background: 'transparent',
    margin: '0',
    padding: '0',
    fontSize: '0.875rem',
    fontWeight: '400',
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: '2rem',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    padding: '0 0.5rem',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '0.875rem',
    backgroundColor: state.isFocused ? '#f4f4f4' : '#fff',
    color: '#222',
    cursor: 'pointer',
    fontWeight: '400',
    padding: '6px 12px',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: '#f4f4f4',
    },
    borderRadius: '0.375rem',
  }),
  menu: (provided: any) => ({
    ...provided,
    fontSize: '0.875rem',
    zIndex: 999,
    overflow: 'hidden',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    padding: '10px',
    marginTop: '4px',
    border: '1px solid #d1d5db',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#000',
    fontSize: '0.875rem',
    margin: '0',
    padding: '0',
  }),
};

export function SelectInput<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  return (
    <div className="h-8 min-h-[32px]">
      <Select<Option, IsMulti, Group>
        {...props}
        classNamePrefix="tw-select"
        styles={customStyles}
      />
    </div>
  )
}


